module.exports = __webpack_public_path__ + "img/icn-04.2b05cdd9.png";